import ndbImg from "../../../../images/contents/map/navaids/NDB.png";
import tacanImg from "../../../../images/contents/map/navaids/TACAN.png"
import vorImg from "../../../../images/contents/map/navaids/VOR.png"
import vorDmeImg from "../../../../images/contents/map/navaids/VOR_DME.png"
import vorTacImg from "../../../../images/contents/map/navaids/VOR_TAC.png"

export const configNavaidsDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/navaids",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/navaids/%index%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 6,
      "download_max": 32,
      "BoundingBox": {
        "West": -180.0,
        "South": -90.0,
        "East": 180.0,
        "North": 90.0
      }
    }
  }
}

export const configNavaidsLayer = {
  "Name": "Navaids",
  "Renderer": "GeoJSON",
  "Attributes": {
    "min_zoom": 6,
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "VOR"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": vorImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "VORDME"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": vorDmeImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "VORTAC"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": vorTacImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "TACAN"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": tacanImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "NDB"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": ndbImg
          }
        }
      }
    ]
  }
};
